import dayjs from 'dayjs';
import { lbApiBeta } from '@/utils/axiosConfig';
import { getCookie } from '@/utils/cookies';
import { isInAppWebView } from '@/utils/appBridge';

// The Trustpilot rating box (RatingTrustpilot.vue, global modal
// 'RatingModal') is shown once per account through the server's seen API,
// like relocasa-app's rating popup (key 'app-rating-modal'), so it follows
// the member across browsers and devices.
export const RATING_MODAL_SEEN_KEY = 'web-rating-modal';
export const RATING_MODAL_DELAY_MS = 30000;

const RATING_MODAL_COUNTRIES = ['nl', 'de', 'dk'];
const MIN_DAYS_SINCE_REGISTRATION = 2;

// Before the seen API the box was counted in these cookies, per browser.
const LEGACY_SEEN_COOKIES = ['lb-rating-modal-seen', 'lb-rating-modal-seen-dk'];

const seenPath = `/api/seen/${RATING_MODAL_SEEN_KEY}`;

export async function markRatingModalSeen() {
  try {
    await lbApiBeta.post(seenPath);
  } catch (e) {
    // At worst the box shows once more.
  }
}

// Whether to show the box on this page load. Inside relocasa-app's WebView
// the app hides it, so it is neither shown nor marked as seen there.
export async function shouldShowRatingModal({
  country,
  isAuthenticated,
  registeredAt
}) {
  if (!isAuthenticated || !RATING_MODAL_COUNTRIES.includes(country)) {
    return false;
  }
  if (isInAppWebView()) return false;
  if (
    !registeredAt ||
    !dayjs(registeredAt).isBefore(
      dayjs().subtract(MIN_DAYS_SINCE_REGISTRATION, 'day')
    )
  ) {
    return false;
  }

  if (LEGACY_SEEN_COOKIES.some(cookie => getCookie(cookie))) {
    await markRatingModalSeen();
    return false;
  }

  try {
    const { data } = await lbApiBeta.get(seenPath);
    return data === false;
  } catch (e) {
    return false;
  }
}
